export const ToastMessages = {
  common: {
    REQUIRED_FIELDS: 'Please fill all required fields.',
    INVALID_INPUT: 'Some fields have invalid input.',
    TRY_AGAIN: 'Something went wrong. Please try again.',
    UNEXPECTED_ERROR_TRY_AGAIN: 'Something went wrong. Please try again.',
    SOMETHING_WENT_MISSING_TRY_AGAIN:
      'Looks like something went missing. Please refresh or try again soon.',
    FAILED_TO_SAVE_CHANGES: 'Failed to save changes',
    ERROR_OCCURRED_TRY_LATER_OR_CONTACT_ADMIN:
      'Error occurred. Try again later or contact your administrator.',
    REQUEST_COMPLETED: 'This request has already been completed.',
  },

  verifyToken: {
    error: {
      INVALID_AUTHENTICATION: 'Invalid authentication request',
    },
  },
  onboarding: {
    success: {
      ONBOARDING_COMPLETED:
        'Great job! You’ve taken an important first step towards understanding your wellbeing. Keep exploring to unlock your personalised insights.',
    },
  },

  checkIn: {
    success: {
      CHECK_IN_SAVED:
        'Check-in saved! Taking a moment to reflect on your wellbeing is always worthwhile.',
    },
    error: {
      QUESTIONNAIRE_NOT_FOUND: 'Sorry, assessment not found',
      CHECK_IN_SAVE_UNSUCCESSFUL: 'Sorry, we couldn’t save your results. Please try again.',
      ANSWER_ALL_QUESTIONS: 'Please answer all questions before submitting',
    },
  },

  priorities: {
    success: {
      PRIORITIES_SAVED_SUCCESSFULLY:
        'Priorities set! You’re now focused on what matters most for you.',
    },
    info: {
      ALL_THE_AREAS_ALREADY_ADDED: 'All priorities are already added.',
    },
    error: {
      MAXIMUM_10_PRIORITIES: 'You can only select up to 10 priorities.',
      CREATE_ASSESSMENT_FIRST: 'Please create an assessment first.',
      ERROR_OCCURRED_WHEN_REMOVING: 'Sorry, an error occurred when removing priorities.',
    },
  },

  journal: {
    success: {
      REFLECTION_SAVED:
        'Your reflection is saved. Taking time to reflect supports your wellbeing journey.',
    },
    error: {
      ERROR_SUBMITTING: 'Sorry, we couldn’t save your reflection. Please try again.',
      PLEASE_ENTER_YOUR_REFLECTION: 'Please enter your reflection',
    },
  },

  questionnaireV2: {
    success: {},
    info: {},
    error: {
      QUESTIONNAIRE_IS_MISSING: 'Assessment is missing. Please try again!',
    },
  },

  talkToAdvisor: {
    success: {
      SUCCESSFULLY_SHARED: 'Your request is successfully sent.',
    },
    info: {},
    error: {
      QUESTIONNAIRE_NOT_SELECTED: 'Assessment not selected',
    },
  },

  booking: {
    success: {
      BOOKING_SUCCESSFUL:
        'Your booking is successful. Please check your email for confirmation and more information.',
    },
    info: {},
    error: {
      BOOKING_FAILED: 'Sorry, booking is failed. Please try again.',
    },
  },

  createSpeakUp: {
    success: {
      MESSAGE_SHARED_SUCCESSFULLY: 'Thank you, your message has been successfully shared.',
      YOUR_THOUGHT_SAVED: 'Your thoughts have been saved',
    },
    info: {
      PLEASE_SELECT_A_QUESTIONNAIRE: 'Please select a questionnaire',
    },
    error: {
      YOU_HAVE_EXCEEDED_YOUR_CREATE_SPEAK_UP_LIMIT:
        'We’ve received several messages from you recently and want to ensure you get the proper attention you deserve. Please allow time for your team to respond thoughtfully to your concerns. If you need urgent help, please click here to access urgent help resources.',
      QUESTIONNAIRE_AND_DESCRIPTION_REQUIRED:
        'Please write a message and select a question to share.',
      PLEASE_SELECT_QUESTION_TO_SHARE: 'Please select a question to share',
      PLEASE_ENTER_MESSAGE: 'Please enter a message',
    },
  },

  instantMessaging: {
    error: {
      WAIT_UNTIL_PREVIOUS_MESSAGE: 'Please wait until the previous message is sent.',
    },
  },

  dashboard: {
    success: {
      DATA_FETCHED: 'Your dashboard is ready to explore.',
    },
    error: {
      DATA_FETCH_FAILED:
        'We’re having trouble loading your dashboard. Please try refreshing the page.',
    },
  },

  experts: {
    success: {
      SESSION_CANCELLED: 'Your expert booking session is cancelled successfully',
    },
    error: {},
    info: {},
  },

  action: {
    success: {
      ACTION_UPDATED: 'Action updated successfully.',
      ACTION_REMOVED: 'Action removed from your plan.',
      ACTION_CREATED: 'New action added to your plan.',
      ACTION_COMPLETED: 'Action completed!',
    },
    error: {},
    info: { ACTION_ALREADY_COMPLETED: 'Action already completed!' },
  },

  auth: {
    success: {
      LOGIN: 'Welcome back!',
      LOGOUT: 'See you soon!',
    },
    error: {
      LOGIN_FAILED: 'Invalid credentials.',
      UNAUTHORIZED: 'You are not authorized.',
    },
  },
} as const;

export type ToastSection = keyof typeof ToastMessages;
export type ToastType<T extends ToastSection> = keyof (typeof ToastMessages)[T];
